__turbopack_context__.v({
  "card": "CardProductCategory-module-scss-module__ifyqwG__card",
  "card--card": "CardProductCategory-module-scss-module__ifyqwG__card--card",
  "card--dark-text": "CardProductCategory-module-scss-module__ifyqwG__card--dark-text",
  "card--detail": "CardProductCategory-module-scss-module__ifyqwG__card--detail",
  "card--square": "CardProductCategory-module-scss-module__ifyqwG__card--square",
  "card--trio": "CardProductCategory-module-scss-module__ifyqwG__card--trio",
  "cardInner": "CardProductCategory-module-scss-module__ifyqwG__cardInner",
  "cardLink": "CardProductCategory-module-scss-module__ifyqwG__cardLink",
  "cta": "CardProductCategory-module-scss-module__ifyqwG__cta",
  "fullWidth": "CardProductCategory-module-scss-module__ifyqwG__fullWidth",
  "icon": "CardProductCategory-module-scss-module__ifyqwG__icon",
  "image": "CardProductCategory-module-scss-module__ifyqwG__image",
});
